import React from 'react';
import CatalogConfiguratorStore from '../../_flux/stores/catalog_configurator_store';
import {
    setOutOfStockLoadingAction,
    setOutOfStockLoadingDoneAction,
    setOutOfStockAction,
    setInStockAction,
    hideTyreIndexAction,
} from '../../_flux/actions/catalog_configurator_actions';
import { updateAvailableFilterOptionsAction } from '../../_flux/actions/filter_available_options_actions';
import { updateFilterOptionsAction } from '../../_flux/actions/filter_options_actions';
import { Filters } from '../../_flux/constants/filter/filters';
import { requestConfiguratorOptions } from '../../_modules/requests/request_configurator_options';
import { resetFiltersAfterFilter } from './reset_filters_after_change';
import { types } from '../../_constants/product/types';

export function checkFor(productType, filters, fieldsToBeChecked, changedFilter) {
    const arrFieldsToBeChecked = [fieldsToBeChecked];
    setOutOfStockLoadingAction(fieldsToBeChecked);
    let currentConfiguratorType = productType;
    if ([types.TYRE_CAR, types.TYRE_MOTO].indexOf(productType) !== -1) {
        currentConfiguratorType = CatalogConfiguratorStore.getState().configuratorType;
    }

    const tyreFilters = Object.assign({}, filters, { category: currentConfiguratorType });
    requestConfiguratorOptions(tyreFilters, arrFieldsToBeChecked)
        .then((response) => {
            setOutOfStockLoadingDoneAction();
            if (response[fieldsToBeChecked].length) {
                if (CatalogConfiguratorStore.getState().outOfStock) {
                    setInStockAction(productType);
                }
            } else {
                // hack.. some moto tyres don't have a load index
                if (types.TYRE_MOTO === currentConfiguratorType && fieldsToBeChecked === Filters.LOAD_INDEX) {
                    requestConfiguratorOptions(tyreFilters, [Filters.MANUFACTURER])
                        .done(() => {
                            hideTyreIndexAction();
                            if (CatalogConfiguratorStore.getState().outOfStock) {
                                setInStockAction(productType);
                            }
                        })
                        .catch(() => {
                            resetFiltersAfterFilter(changedFilter, productType);
                            setOutOfStockAction(changedFilter, productType);
                        });
                }
                // Standard behaviour without the hack
                else {
                    resetFiltersAfterFilter(changedFilter, productType);
                    setOutOfStockAction(changedFilter, productType);
                }
            }

            return response;
        })
        .then((response) => {
            const loadIndexFilterName = Filters.LOAD_INDEX;
            const speedIndexFilterName = Filters.SPEED_INDEX;

            if (fieldsToBeChecked === loadIndexFilterName) {
                updateAvailableFilterOptionsAction({
                    [loadIndexFilterName]: response[loadIndexFilterName].map((option) => {
                        const [value] = option;
                        return typeof value === 'string' ? value.toUpperCase() : value;
                    })
                });
            } else if (fieldsToBeChecked === speedIndexFilterName) {
                updateAvailableFilterOptionsAction({
                    [speedIndexFilterName]: response[speedIndexFilterName].map(option => option[0])
                });
            } else {
                if ([Filters.HEIGHT, Filters.DIAMETER].indexOf(fieldsToBeChecked) >= 0) {
                    updateFilterOptionsAction(response);
                }
            }
        });
}
